import { render } from "./CompanyDetails.vue?vue&type=template&id=62fe6a71&scoped=true&ts=true"
import script from "./CompanyDetails.vue?vue&type=script&lang=ts"
export * from "./CompanyDetails.vue?vue&type=script&lang=ts"

import "./CompanyDetails.vue?vue&type=style&index=0&id=62fe6a71&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62fe6a71"]])

export default __exports__